export default __webpack_public_path__ + "assets/ico_match-16176299.svg";